define('viewmodels/AMLRiskAssessment/AMLInherentRiskAssessment',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/system', 'services/appsecurity', 'durandal/app', 'viewmodels/Weightings_Thresholds/AMLThresholds', 'viewmodels/Weightings_Thresholds/InherentWeightings', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, navigation, logger, system, appsecurity, app, Thresholds, Weightings, utils, ObjGeneralSettings) {
        AMLRaViewModel = {
            activate: activate,
            attached: attached,
            detached: detached,
            utils: utils,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            openWeightings: openWeightings,
            Weightings: Weightings,
            Thresholds: Thresholds,
            ExportQualDataExcel: ExportQualDataExcel,
            ExportToExcelQualQuanCheck: ExportToExcelQualQuanCheck,
            GetRfThresholdRules: GetRfThresholdRules,
            ShowComments: ShowComments,
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            ClearResult: ClearResult,
            ResetSearch: ResetSearch,
            SearchResult: SearchResult,
            SubCheckboxSelected: SubCheckboxSelected,
            ClearOrgFilterSelection: ClearOrgFilterSelection,
            ClearBUFilterSelection: ClearBUFilterSelection,
            ApplyBuFitlers: ApplyBuFitlers,
            ClearAllBuFitlers: ClearAllBuFitlers,
            HeatmapToggle: HeatmapToggle,
            FormatValueData: FormatValueData,
            valuechange: valuechange,
            ExportQuanDataFactorReportToexcel: ExportQuanDataFactorReportToexcel,
            CollapseAllTreeView: CollapseAllTreeView,
            ExpandAllTreeView: ExpandAllTreeView,
            SearchTreeView: SearchTreeView,
            NavigationMenuHideShow: NavigationMenuHideShow,
            DistributionToggle: DistributionToggle,
            collapse: collapse,
            expand: expand,
            expandQualitative: expandQualitative,
            expandQuan: expandQuan,
            expandFactQuan: expandFactQuan,
            //ko-observables start here
            BUTitle: ko.observable('Business Unit'),
            AssessmentType: ko.observable(''),
            AssessmentTypeId: ko.observable(),
            ClickedRiskAreaId: ko.observable(),
            ClickedRiskAreaName: ko.observable(),
            ClickedRiskFactor: ko.observable(),
            ClickedRiskFactorName: ko.observable(),
            Type: ko.observable(),
            countEntry: ko.observable(false),
            IsOverall: ko.observable(),
            editableResponseType: ko.observable(),
            SelectedType: ko.observable(),
            ISRAT: ko.observable(),
            RiskAreaList: ko.observableArray([]),
            RiskFactorList: ko.observableArray([]),
            FinalRiskLevelList: ko.observableArray([]),
            AllFinalRiskLevelList: ko.observableArray([]),
            RiskAreaWiseHeatmap: ko.observableArray([]),
            OverrideCommentsList: ko.observableArray([]),
            InherentRFWeigthingsList: ko.observableArray([]),
            ColspanValue: ko.observable(2),
            ScreenName: ko.observable(),
            showQualResponseCommentsPopUp: showQualResponseCommentsPopUp,
            QualResponseCommentsList: ko.observableArray([]),
            IsSideNavOpen: ko.observable(0),
            OrgLvlDrpDwnList: ko.observableArray(),
            OrgLvlValueList: ko.observableArray(),
            BusinessUnitListForFilters: ko.observableArray([]),
            BusinessUnitListForFiltersDUP: ko.observableArray([]),
            SelectedCheckedList: ko.observableArray([]),
            SelectedCheckedBUList: ko.observableArray([]),
            BUFiltersApplied: ko.observable(false),
            FiltersListFlag: ko.observable(false),
            FinalOrgFilterList: ko.observableArray([]),
            DistinctFileredBUs: ko.observableArray([]),
            NumberOfBUsSelectedRA: ko.observable(0),
            SubFactorDataList: ko.observable(),
            LocaleCheckFlag: ko.observable(false),
            ClickedRiskAreaType: ko.observable(),
            AreaName: ko.observable(),
            AreaType: ko.observable(),
            hasSubArea: ko.observable(),
            SurveyCategoryList: ko.observableArray([]),
            SelectedSurveyComponentId: ko.observable(),
            SurveyCategoryTabClick: SurveyCategoryTabClick,
            SubFactorGridDataList: ko.observableArray([]),
            CalRiskBasedOnColumnsList: ko.observableArray([]),
            ColspanValueMin: ko.observable(1),
            CalBottomLevelModelList: ko.observableArray([]),
            TotalSubFactorDataList: ko.observableArray([]),
            DistributionDataList: ko.observableArray([]),
            DistributionFlag: ko.observable(false),
            RiskFactorFlag: ko.observable(true),
            SelectedBUIds: ko.observable(""),
            //qual
            ClickedSubRiskAreaId: ko.observable(),
            HeatmapFlag: ko.observable(false),
            BusinessUnitListQual: ko.observableArray([]),
            BusinessUnitListQuan: ko.observableArray([]),
            editableResponseTypeQual: ko.observableArray([]),
            SubFactorGridDataListQual: ko.observableArray([]),
            CalculatedBottomLevelsQual: ko.observableArray([]),
            RiskFactorFlagQual: ko.observable(true),
            CurrencyNameSelected: ko.observable(''),
            CurrencyTypeSelected: ko.observable(''),
            ShowOverAllScoreFlag: ko.observable(0),
            jsonResultActual: ko.observableArray([]),
            jsonResultActualQual: ko.observableArray([]),
            SubFactorGridDataListDUP: ko.observableArray([]),
            DataTableColumnWidth: ko.observable(''),
            BreadCrumbArray: ko.observable(''),
            AreaLeveljstree: ko.observableArray([]),
            SurveyTypeClicked: ko.observable(),
            hasChildNodes: ko.observable(false),
            SubFactorGridDataListQualDUP: ko.observableArray([]),
            WTBusinessUnits: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            inherentWeight: ko.observableArray([]),
            decimalLimit: ko.observableArray([]),
            totalValidityFlag: ko.observable(),
            EditableBusinessunitTotal: ko.observable(),
            ThresholdValuesList: ko.observableArray([]),
            QualThresholdValuesList: ko.observableArray([]),
            ThresholdChildList: ko.observableArray([]),
            ColspanWidth: ko.observable(''),
            Query: ko.observable(),
            SubFactorGridDataListCur: ko.observableArray([]),
            QuanColumnTypes: ko.observableArray([]),
            QuanAreaColspan: ko.observable(),
            InhQualstate: ko.observable(false),
            RiskQualFlag: ko.observable(false),
            ShowOverallQuan: ko.observable(false),
            Inhstate: ko.observable(false),
            FactState: ko.observable(true),
            RiskFactorQuanFlag: ko.observable(true),
        };

        return AMLRaViewModel;

        //#region Page Load Methods

        function activate() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(0)).addClass('active');
                $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(0)).addClass('active');
                var Id = AMLRaViewModel.appsecurity.getParameterByName('atype');
                AMLRaViewModel.AssessmentTypeId(Id);
                AMLRaViewModel.appsecurity.GetAssessmentNames().then(function () {

                    AMLRaViewModel.AssessmentType(AMLRaViewModel.appsecurity.GetAssessmentName(AMLRaViewModel.AssessmentTypeId()))
                    AMLRaViewModel.ScreenName(AMLRaViewModel.AssessmentType() + ' ' + ((!AMLRaViewModel.LocaleCheckFlag() || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentRiskAssessment') == -1) ? 'Inherent Risk Assessment' : AMLRaViewModel.ObjGeneralSettings.LocalizedTextList()[AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentRiskAssessment')].Name()));
                })

                if (AMLRaViewModel.ObjGeneralSettings === undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AMLRaViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    AMLRaViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {

                        if (AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            AMLRaViewModel.LocaleCheckFlag(false);
                        else
                            AMLRaViewModel.LocaleCheckFlag(true);
                    });
                }
                else {
                    if (AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        AMLRaViewModel.LocaleCheckFlag(false);
                    else
                        AMLRaViewModel.LocaleCheckFlag(true);
                }

                AMLRaViewModel.BUTitle((AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLRaViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList() == null || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : AMLRaViewModel.ObjGeneralSettings.LocalizedTextList()[AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

                AMLRaViewModel.BreadCrumbArray('');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(0)).removeClass('active');
            }
            catch (e) {
                var msg = 'exception' + e + 'source in detached() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                $("#divNavSwitchHideInh").hide();
                GetSurveyCategoryTabs();
                AMLRaViewModel.SelectedCheckedBUList([]);
                AMLRaViewModel.SelectedCheckedList([]);
                closeSideNav();
                AMLRaViewModel.BUFiltersApplied(false);
                AMLRaViewModel.FiltersListFlag(false);
                AMLRaViewModel.NumberOfBUsSelectedRA(0);
                $('.badge').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');
            }
            catch (e) {
                var msg = 'exception' + e + 'source in attached() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        // #region Tab Clicks

        function SurveyCategoryTabClick(data, event) {
            try {
                $('.SurveyCategoryTabClass').removeClass("active");
                $('#SurveyCategoryTab_' + data.SurveyCategoryId()).addClass("active");
                NavigationMenuHideShow('Show');
                $('#QuanGrid').hide();
                $('#QualGrid').hide();
                AMLRaViewModel.SelectedSurveyComponentId(data.SurveyCategoryId());
                AMLRaViewModel.RiskAreaList([]);
                AMLRaViewModel.ClickedRiskFactor([]);

                AMLRaViewModel.SurveyTypeClicked(data.SurveyGroupShortName());

                var QType = 'QUAL';
                if (data.SurveyGroupShortName() == 'QTDR') {
                    QType = 'QTDR';
                    AMLRaViewModel.ISRAT(false)
                    AMLRaViewModel.SelectedType('QUAN')
                    $('#RiskLevelTabinnerDiv').show();
                    $('#FactorReportDownload').show();
                    $('#WeightingsBtnQuan').show();
                    $('#RiskLevelInnerTabDivforHeatmap').show();
                    $('#factorstab').show();
                    $('#ORTAB').empty();
                    $('#CurrencyDropDown').show();
                    $('#BusinessUnitFilterBtn').show();
                    $('#ThresholdsBtn').show();
                } else {
                    $('#RiskLevelTabinnerDiv').hide();
                    $('#RiskLevelInnerTabDivforHeatmap').hide();
                    $('#factorstab').hide();
                    $('#CurrencyDropDown').hide();
                    $('#FactorReportDownload').hide();
                    $('#NoFactorsError').hide();
                    $('#NoSubFactorsError').hide();
                    $('#ThresholdsBtn').show();
                    $('#WeightingsBtnQuan').hide();
                }
                AMLRaViewModel.ClickedRiskAreaType(QType);
                InitiateLevelTree();
                $("#spanExpandAll").text((!AMLRaViewModel.LocaleCheckFlag() || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLRaViewModel.ObjGeneralSettings.LocalizedTextList()[AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpan").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region Get Methods

        function GetSurveyCategoryTabs() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetSurveyCategoryTabsByAssessmentType",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": AMLRaViewModel.AssessmentTypeId(), "ScreenType": "RA" }
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                AMLRaViewModel.SurveyCategoryList(mappedTabList);
                                $('#SurveyCategoryTab').tabs();
                                $('#SurveyCategoryTab').tabs('refresh');
                                $('#SurveyCategoryTab').tabs({ active: 0 });
                                $($('#SurveyCategoryTab li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                            else {
                                var msg = 'An error occurred. Please contact your Application Administrator.';
                                logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in AmlInherentRiskAssessment.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in AmlInherentRiskAssessment.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetAllQuantitativeData() {
            try {
                //set flags for distribution and risk factor toggles
                $('#QuanFactorGrid').hide();
                $('#QuanAreaGrid').hide();
                var tableId = "";
                var type = '';
                if (AMLRaViewModel.Type() === 'F') {
                    AMLRaViewModel.ShowOverallQuan(false);
                    tableId = AMLRaViewModel.ClickedRiskFactor();
                    type = 'F';
                } else if (AMLRaViewModel.Type() === 'A') {
                    tableId = AMLRaViewModel.ClickedRiskAreaId();
                    type = 'A';
                }

                //set applicable filters on apply/clear filter
                var businessUnitIds = "";
                AMLRaViewModel.SelectedBUIds('');
                if (AMLRaViewModel.BUFiltersApplied() == true) {
                    if (AMLRaViewModel.BusinessUnitListForFilters() != undefined && AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                        for (var i = 0; i < AMLRaViewModel.BusinessUnitListForFilters().length; i++) {
                            if (i == 0)
                                businessUnitIds = AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                            else
                                businessUnitIds = businessUnitIds + ',' + AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                        AMLRaViewModel.SelectedBUIds(businessUnitIds);
                    }
                }
                if (AMLRaViewModel.Type() == 'O')
                    type = 'A';

                $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllQuantitativeData",
                    type: "GET",
                    data: {
                        "RiskId": tableId, "AssessmentTypeId": AMLRaViewModel.AssessmentTypeId(),
                        "SurveyCategoryID": AMLRaViewModel.SelectedSurveyComponentId(), "TableType": type,
                        "BusinessUnitIds": AMLRaViewModel.SelectedBUIds()
                    },
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllQuantitativeData() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.Incident_Description == null) {
                        AMLRaViewModel.BreadCrumbArray('');
                        if (jsonResult.breadCrumbList != undefined)
                            AMLRaViewModel.BreadCrumbArray(jsonResult.breadCrumbList);

                        if (jsonResult.BusinessUnitList.length > 0) {
                            AMLRaViewModel.jsonResultActual([]);
                            AMLRaViewModel.jsonResultActual(jsonResult);

                            AMLRaViewModel.editableResponseType([]);
                            AMLRaViewModel.BusinessUnitListQuan([]);
                            $('#NoBussinessUnitserror').hide();
                            var mappedBuList = $.map(jsonResult.BusinessUnitList, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            AMLRaViewModel.BusinessUnitListQuan(mappedBuList);
                            AMLRaViewModel.NumberOfBUsSelectedRA(mappedBuList.length);

                            if (jsonResult.ColumnTypes.length > 0) {
                                AMLRaViewModel.QuanColumnTypes([]);
                                var mappedColumnList = $.map(jsonResult.ColumnTypes, function (result) {
                                    return new QuanColumnTypeModel(result);
                                });
                                AMLRaViewModel.QuanColumnTypes(mappedColumnList);
                            }
                            if (AMLRaViewModel.Type() === 'A') {
                                AMLRaViewModel.QuanAreaColspan(AMLRaViewModel.QuanColumnTypes().length);
                            }

                            if (jsonResult.EditableResponseTypes.length > 0) {
                                AMLRaViewModel.editableResponseType([]);
                                var mappedresponseColumnList = $.map(jsonResult.EditableResponseTypes, function (result) {
                                    if (result.calculationapplicability == true) {
                                        return new QuantitativeResponseColumnsModel(result);
                                    }
                                });
                                AMLRaViewModel.editableResponseType(mappedresponseColumnList);
                                AMLRaViewModel.ColspanValue(mappedresponseColumnList.length);
                                AMLRaViewModel.ColspanValueMin(mappedresponseColumnList.length - 1);
                            }

                        }

                        AMLRaViewModel.SubFactorGridDataList([]);
                        AMLRaViewModel.SubFactorGridDataListDUP([]);
                        AMLRaViewModel.SubFactorGridDataListCur([]);

                        if (AMLRaViewModel.RiskFactorFlag() == true) {
                            if (jsonResult.SubFactorDataList.length > 0) {
                                AMLRaViewModel.SubFactorGridDataListDUP(jsonResult.SubFactorDataList);
                                AMLRaViewModel.SubFactorGridDataListCur(jsonResult.SubFactorDataList);
                                AMLRaViewModel.SubFactorGridDataList(jsonResult.SubFactorDataList);
                            }
                        }

                        if (jsonResult.ResponseValuesPerBU.length > 0) {
                            AMLRaViewModel.CalRiskBasedOnColumnsList([]);
                            var MappedObject = $.map(jsonResult.ResponseValuesPerBU, function (result) {
                                return new ColumnwiseriskListModel(result);
                            });
                            AMLRaViewModel.CalRiskBasedOnColumnsList(MappedObject);
                        }

                        AMLRaViewModel.DistributionDataList([]);
                        if (jsonResult.DistributionList.length > 0) {
                            AMLRaViewModel.DistributionDataList(jsonResult.DistributionList);
                        }
                        if (jsonResult.TotalSubFactorDataList.length > 0) {
                            AMLRaViewModel.TotalSubFactorDataList([]);
                            var MappedObject = $.map(jsonResult.TotalSubFactorDataList, function (result) {
                                return new SubFactorDataModel(result);
                            });
                            AMLRaViewModel.TotalSubFactorDataList(MappedObject);
                        }
                        if (jsonResult.CalculatedBottomLevels.length > 0) {
                            AMLRaViewModel.CalBottomLevelModelList([]);
                            var MappedObject = $.map(jsonResult.CalculatedBottomLevels, function (result) {
                                return new CalculatedBottomLevelModel(result);
                            });
                            AMLRaViewModel.CalBottomLevelModelList(MappedObject);
                        }

                        if (AMLRaViewModel.Type() === "F") {
                            $('#tblRAQuan tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#tblRAQuan thead').css("left", -$("#tblRAQuan tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#tblRAQuan thead th:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first cell of the header
                                $('#tblRAQuan tbody td:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first column of tdbody
                            });
                            $('#QuanFactorGrid').show();

                        } else if (AMLRaViewModel.Type() === 'A') {
                            //collapse all bu coloumn on first load
                            collapseAllOnLoad();
                            $('#tblRAQuanOverAllQ tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#tblRAQuanOverAllQ thead').css("left", -$("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#tblRAQuanOverAllQ thead th:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first cell of the header
                                $('#tblRAQuanOverAllQ tbody th:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first column of tdbody
                                $('#tblRAQuanOverAllQ tbody td:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first column of tdbody
                            });
                            $('#QuanAreaGrid').show();
                        }

                    }
                    else {
                        if (jsonResult == null || jsonResult == undefined) {
                            $('#Rb').hide();
                            $('#NoFacError').show();
                        }
                        else {
                            $('#Rb').hide();
                            $('#NoFacError').show();
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllQuantitativeData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllQuantitativeData() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllQuantitativeData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function expandQuan() {
            if (AMLRaViewModel.Inhstate() == false) {
                //expand
                AMLRaViewModel.ShowOverallQuan(true);
                AMLRaViewModel.Inhstate(true);
                $("#spanInhQuan").addClass("fa-caret-down").removeClass("fa-caret-right");

            }
            else {
                //collapse
                AMLRaViewModel.ShowOverallQuan(false);
                AMLRaViewModel.Inhstate(false);
                $("#spanInhQuan").addClass("fa-caret-right").removeClass("fa-caret-down");
                AMLRaViewModel.ColspanValue(AMLRaViewModel.editableResponseType().length);
            }
        }

        function DistributionToggle(data, event) {
            try {
                if ($("#Riskfactorevent").is(':checked')) {
                    AMLRaViewModel.DistributionFlag(true);
                }
                else {
                    AMLRaViewModel.DistributionFlag(false);
                }

                UpdateDistributionData();
            }
            catch (e) {
                var msg = 'exception' + e + ' DistributionToggle() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function expandFactQuan() {
            if (AMLRaViewModel.FactState() == false) {
                //expand
                AMLRaViewModel.RiskFactorQuanFlag(true);
                AMLRaViewModel.FactState(true);
                $("#spanFactQuan").addClass("fa-caret-down").removeClass("fa-caret-right");
                if (AMLRaViewModel.Query() != "") {
                    SearchResult();
                }
            }
            else {
                //collapse
                AMLRaViewModel.RiskFactorQuanFlag(false);
                AMLRaViewModel.FactState(false);
                $("#spanFactQuan").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        function expandQualitative() {
            if (AMLRaViewModel.InhQualstate() == false) {
                //expand
                AMLRaViewModel.RiskQualFlag(true);
                AMLRaViewModel.InhQualstate(true);
                $("#spanQual").addClass("fa-caret-down").removeClass("fa-caret-right");
                if (AMLRaViewModel.Query() != "") {
                    SearchResult();
                }
            }
            else {
                //collapse
                AMLRaViewModel.RiskQualFlag(false);
                AMLRaViewModel.InhQualstate(false);
                $("#spanQual").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        function collapseAllOnLoad() {
            try {
                for (var i = 0; i < AMLRaViewModel.BusinessUnitListQuan().length; i++) {
                    collapse(AMLRaViewModel.BusinessUnitListQuan()[i].BusinessUnitId());
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: collapseAllOnLoad() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function collapse(Id) {
            try {

                $("#ICexapnd" + Id).show();
                $("#ICcollapse" + Id).hide();

                // 1st row
                if ($("#QnAreaBu_" + Id) != undefined && $("#QnAreaBu_" + Id)[0] != undefined)
                    $("#QnAreaBu_" + Id)[0].colSpan = 1;

                // 2nd row
                $('#Bu' + Id + '-T').hide();
                $('#Bu' + Id + '-Q').hide();
                $('#Bu' + Id + '-W').hide();

                // 3rd row
                $('#BuT' + Id + '-T').hide();
                $('#BuT' + Id + '-Q').hide();
                $('#BuT' + Id + '-W').hide();

                //Rest all rows
                if (AMLRaViewModel.SubFactorGridDataList() != undefined) {
                    for (var i = 0; i < AMLRaViewModel.SubFactorGridDataList().length; i++) {
                        var counter = 0;
                        for (var j = 0; j < AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList.length; j++) {
                            for (var k = 0; k < AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList[j].ResponseList.length; k++) {
                                if (Id == AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList[j].ResponseList[k].Response_BUId) {
                                    var cellData = AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList[j].ResponseList[k];
                                    counter++;
                                    $('#BuR' + Id + '-' + cellData.SubFactorId + '-T').hide();
                                    $('#BuR' + Id + '-' + cellData.SubFactorId + '-Q').hide();
                                    $('#BuR' + Id + '-' + cellData.SubFactorId + '-W').hide();
                                }
                            }
                            if (counter > 0)
                                break;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: collapse() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function expand(Id) {
            try {

                $("#ICcollapse" + Id).show();
                $("#ICexapnd" + Id).hide();

                // 1st row
                if ($("#QnAreaBu_" + Id) != undefined && $("#QnAreaBu_" + Id)[0] != undefined)
                    $("#QnAreaBu_" + Id)[0].colSpan = AMLRaViewModel.QuanColumnTypes().length;

                // 2nd row
                $('#Bu' + Id + '-T').show();
                $('#Bu' + Id + '-Q').show();
                $('#Bu' + Id + '-W').show();

                // 3rd row
                $('#BuT' + Id + '-T').show();
                $('#BuT' + Id + '-Q').show();
                $('#BuT' + Id + '-W').show();

                //Rest all rows
                if (AMLRaViewModel.SubFactorGridDataList() != undefined) {
                    for (var i = 0; i < AMLRaViewModel.SubFactorGridDataList().length; i++) {
                        var counter = 0;
                        for (var j = 0; j < AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList.length; j++) {
                            for (var k = 0; k < AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList[j].ResponseList.length; k++) {
                                if (Id == AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList[j].ResponseList[k].Response_BUId) {
                                    var cellData = AMLRaViewModel.SubFactorGridDataList()[i].BusinessUnitCountList[j].ResponseList[k];
                                    counter++;
                                    $('#BuR' + Id + '-' + cellData.SubFactorId + '-T').show();
                                    $('#BuR' + Id + '-' + cellData.SubFactorId + '-Q').show();
                                    $('#BuR' + Id + '-' + cellData.SubFactorId + '-W').show();
                                }
                            }
                            if (counter > 0)
                                break;
                        }
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: expand() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }


        function GetAllQualitativeData() {
            try {
                $("#QualOverallGrid").hide();
                $("#QualInnerGrid").hide();

                if (AMLRaViewModel.HeatmapFlag() == true)
                    $('#HeatmapToggleeventQualRA').prop('checked', true);
                else
                    $('#HeatmapToggleeventQualRA').prop('checked', false);

                var AreaId = AMLRaViewModel.ClickedRiskAreaId();

                //set applicable filters on apply/clear filter
                var businessUnitIds = "";
                AMLRaViewModel.SelectedBUIds('');
                if (AMLRaViewModel.BUFiltersApplied() == true) {
                    if (AMLRaViewModel.BusinessUnitListForFilters() != undefined && AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                        for (var i = 0; i < AMLRaViewModel.BusinessUnitListForFilters().length; i++) {
                            if (i == 0)
                                businessUnitIds = AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                            else
                                businessUnitIds = businessUnitIds + ',' + AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                        AMLRaViewModel.SelectedBUIds(businessUnitIds);
                    }
                }

                $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllQualitativeData",
                    type: "GET",
                    data: {
                        "RiskId": AreaId, "AssessmentTypeId": AMLRaViewModel.AssessmentTypeId(),
                        "SurveyCategoryID": AMLRaViewModel.SelectedSurveyComponentId(), "TableType": AMLRaViewModel.Type(),
                        "BusinessUnitIds": AMLRaViewModel.SelectedBUIds()
                    },
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllQualitativeData() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult.Incident_Description == null) {

                        if (jsonResult.BusinessUnitList.length > 0) {
                            AMLRaViewModel.BreadCrumbArray('');
                            AMLRaViewModel.BreadCrumbArray(jsonResult.breadCrumbList);

                            AMLRaViewModel.jsonResultActualQual([]);
                            AMLRaViewModel.jsonResultActualQual(jsonResult);

                            AMLRaViewModel.editableResponseTypeQual([]);
                            AMLRaViewModel.BusinessUnitListQual([]);
                            $('#NoBussinessUnitserror').hide();
                            var mappedBuList = $.map(jsonResult.BusinessUnitList, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            AMLRaViewModel.BusinessUnitListQual(mappedBuList);
                            AMLRaViewModel.NumberOfBUsSelectedRA(mappedBuList.length);

                            if (jsonResult.EditableResponseTypes.length > 0) {
                                AMLRaViewModel.editableResponseTypeQual([]);
                                var mappedresponseColumnList = $.map(jsonResult.EditableResponseTypes, function (result) {
                                    return new QuantitativeResponseColumnsModel(result);
                                });
                                AMLRaViewModel.editableResponseTypeQual(mappedresponseColumnList);
                                AMLRaViewModel.ColspanValue(mappedresponseColumnList.length);
                                AMLRaViewModel.ColspanValueMin(mappedresponseColumnList.length - 1);
                            }
                        }

                        AMLRaViewModel.SubFactorGridDataListQual([]);
                        AMLRaViewModel.SubFactorGridDataListQualDUP([]);
                        if (AMLRaViewModel.RiskFactorFlagQual() == true) {
                            if (jsonResult.SubFactorDataList.length > 0) {
                                var MappedObject = $.map(jsonResult.SubFactorDataList, function (result) {
                                    return new SubFactorDataListModel(result);
                                });
                                AMLRaViewModel.SubFactorGridDataListQual(MappedObject);
                                AMLRaViewModel.SubFactorGridDataListQualDUP(MappedObject);
                            }
                        }

                        if (jsonResult.CalculatedBottomLevels.length > 0) {
                            AMLRaViewModel.CalculatedBottomLevelsQual([]);
                            var MappedObject = $.map(jsonResult.CalculatedBottomLevels, function (result) {
                                return new CalculatedBottomLevelModel(result);
                            });
                            AMLRaViewModel.CalculatedBottomLevelsQual(MappedObject);
                        }

                        if (AMLRaViewModel.Type() === 'A') {
                            $('#tblRAQual tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#tblRAQual thead').css("left", -$("#tblRAQual tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#tblRAQual thead th:nth-child(1)').css("left", $("#tblRAQual tbody").scrollLeft()); //fix the first cell of the header
                                $('#tblRAQual tbody td:nth-child(1)').css("left", $("#tblRAQual tbody").scrollLeft()); //fix the first column of tdbody
                            });
                            $("#QualInnerGrid").show();
                        } else if (AMLRaViewModel.Type() === 'O') {
                            $('#tblRAQualOverall tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#tblRAQualOverall thead').css("left", -$("#tblRAQualOverall tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#tblRAQualOverall thead th:nth-child(1)').css("left", $("#tblRAQualOverall tbody").scrollLeft()); //fix the first cell of the header
                                $('#tblRAQualOverall tbody td:nth-child(1)').css("left", $("#tblRAQualOverall tbody").scrollLeft()); //fix the first column of tdbody
                            });
                            $("#QualOverallGrid").show();
                        }
                    }
                    else {
                        if (jsonResult == null || jsonResult == undefined) {
                            $('#Rb').hide();
                            $('#NoFacError').show();
                        }
                        else {
                            $('#Rb').hide();
                            $('#NoFacError').show();
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllQualitativeData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllQualitativeData() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllQualitativeData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetQualResponseComments(data) {
            try {

                $.ajax({
                    url: "/api/AMLRiskAssessment/GetResponseComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "BusinessUnitId": data.Response_BUId(), "RiskFactorId": data.SubFactorId(), "ResponseTypeId": data.ResponseId(),
                        "AssessmentTypeId": AMLRaViewModel.AssessmentTypeId(), "ZATId": AMLRaViewModel.SelectedSurveyComponentId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualResponseComments() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#QualCommentsMain').show();
                    AMLRaViewModel.QualResponseCommentsList([]);
                    if (jsonResult == null || jsonResult == undefined) {
                        logger.logError('Failed to load Qualitatively Adjusted Rating comments. Please try again.', 'Error', system.getModuleId(AMLRaViewModel), true);
                    }
                    else {
                        if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                            var mappedQualResponseCommentsList = $.map(jsonResult, function (result) {
                                return new ResponseCommentsModel(result);
                            })
                            AMLRaViewModel.QualResponseCommentsList(mappedQualResponseCommentsList);
                            $('#QualResponseComments')[0].scrollTop = $('#QualResponseComments')[0].scrollHeight;
                        }
                        else if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description != null) {
                            var msg = 'Failed to load Qualitatively Adjusted Rating comments. Please try again.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetQualResponseComments() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualResponseComments() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQualResponseComments() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetOverrideComments(businessUnitId) {
            try {

                $.ajax({
                    url: "/api/AMLRiskAssessment/GetOverrideComment",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        BusinessUnitId: businessUnitId, RiskAreaId: parseInt(AMLRaViewModel.ClickedRiskAreaId()), RiskFactorId: parseInt(AMLRaViewModel.ClickedRiskFactor()),
                        CommentType: AMLRaViewModel.Type(), AssessmentType: AMLRaViewModel.AssessmentTypeId(), RiskAreaType: AMLRaViewModel.ClickedRiskAreaType(),
                        ZATId: AMLRaViewModel.SelectedSurveyComponentId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetOverrideComments() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#CommentsMain').show();
                    AMLRaViewModel.OverrideCommentsList([]);
                    if (jsonResult == null || jsonResult == undefined) {
                        logger.logError('Failed to load Qualitatively Adjusted Rating comments. Please try again.', 'Error', system.getModuleId(AMLRaViewModel), true);
                    }
                    else {
                        if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                            var mappedOverrideCommentsList = $.map(jsonResult, function (result) {
                                return new OverrideCommentModel(result);
                            })
                            AMLRaViewModel.OverrideCommentsList(mappedOverrideCommentsList);
                            $('#ResponseComments')[0].scrollTop = $('#ResponseComments')[0].scrollHeight;
                        }
                        else if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description != null) {
                            var msg = 'Failed to load Qualitatively Adjusted Rating comments. Please try again.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetOverrideComments() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverrideComments() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOverrideComments() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetAllOrganizationalLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: AMLRaViewModel.AssessmentTypeId(), YOA: null }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                        var OrganizationalLevels = $.map(jsonResult, function (result) {
                            return new BusinessLevelsModel(result);
                        });
                        if (OrganizationalLevels.length > 0) {
                            AMLRaViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                            AMLRaViewModel.OrgLvlValueList(AMLRaViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                        }
                        GetAllBusinessUnitsForFilters();
                        AMLRaViewModel.SelectedCheckedList([]);
                        AMLRaViewModel.SelectedCheckedBUList([]);
                        document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                    }
                    else {
                        if (jsonResult.length > 0) {
                            var msg = 'An error occurred.Please contact your Application Administrator.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetAllBusinessUnitsForFilters() {
            try {
                return $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllBusinessUnitsForFiltersBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: AMLRaViewModel.AssessmentTypeId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllBusinessUnitsForFilters() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                        var mappedBuList = $.map(jsonResult, function (result) {
                            return new BusinessUnitModel(result);
                        });
                        AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                        AMLRaViewModel.BusinessUnitListForFiltersDUP(mappedBuList);
                        BindHTML();
                        $('#OrgFilterError').hide();
                        $('#BUFilterError').hide();
                        AMLRaViewModel.FiltersListFlag(true);
                    }
                    else {
                        if (jsonResult.length > 0) {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);;
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        // #endregion

        // #region Reports

        function ExportToExcelQualQuanCheck() {
            try {
                //checking condition
                if (AMLRaViewModel.ClickedRiskAreaType() == "QUAL") {
                    ExportQualDataExcel()
                } else {
                    ExportQuanDataFactorReportToexcel()
                }

            } catch (e) {
                var msg = 'Exception' + e + 'source: ExportToExcelQualQuanCheck() in AmlInherentRiskAssessment.js';
                logger.logMessage(e);
            }

        }

        function ExportQualDataExcel() {
            try {
                var ConcatBUList = "";
                if (AMLRaViewModel.BusinessUnitListForFilters() != undefined && AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                    for (var i = 0; i < AMLRaViewModel.BusinessUnitListForFilters().length; i++) {
                        if (i == 0)
                            ConcatBUList += AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        else {
                            ConcatBUList += "," + AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                    }

                }

                var RiskAreaId = 0;
                if (AMLRaViewModel.hasSubArea())
                    RiskAreaId = AMLRaViewModel.ClickedSubRiskAreaId();
                else
                    RiskAreaId = AMLRaViewModel.ClickedRiskAreaId();

                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), RiskAreaID: RiskAreaId, AssessmentType: AMLRaViewModel.AssessmentTypeId(), ZAT_UID: AMLRaViewModel.SelectedSurveyComponentId(), TYPE: AMLRaViewModel.Type(), AreaName: AMLRaViewModel.ClickedRiskAreaName(), BUListString: ConcatBUList  //yoa is not used in report
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadQualitativeReport", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + 'source: ExportQualDataExcel() in AmlInherentRiskAssessment.js';
                logger.logMessage(e);
            }
        }

        function ExportQuanDataFactorReportToexcel(data, event) {
            try {
                var ConcatBUList = "";
                if (AMLRaViewModel.BusinessUnitListForFilters() != undefined && AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                    for (var i = 0; i < AMLRaViewModel.BusinessUnitListForFilters().length; i++) {
                        if (i == 0)
                            ConcatBUList += AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        else {
                            ConcatBUList += "," + AMLRaViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                    }

                }

                if (AMLRaViewModel.Type() === 'A') {
                    var payLoad = {
                        t: appsecurity.getAuthenticationInfo(), RiskAreaID: AMLRaViewModel.ClickedRiskAreaId(), AssessmentType: AMLRaViewModel.AssessmentTypeId(), ZAT_UID: AMLRaViewModel.SelectedSurveyComponentId(), AreaName: AMLRaViewModel.ClickedRiskAreaName(), BUListString: ConcatBUList
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/DownloadQuantitativeOverallReport", payLoad, '_blank');
                }
                else {
                    var payLoad = {
                        t: appsecurity.getAuthenticationInfo(), FactorId: AMLRaViewModel.ClickedRiskFactor(), AssessmentType: AMLRaViewModel.AssessmentTypeId(), FactorName: AMLRaViewModel.ClickedRiskFactorName(), BUListString: ConcatBUList//yoa is not used in report
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/DownloadQuantitativeReport", payLoad, '_blank');
                }
            }
            catch (e) {
                var msg = 'Exception' + e + 'source: ExportQuanDataFactorReportToexcel() in AmlInherentRiskAssessment.js';
                logger.logMessage(e);
            }
        }

        // #endregion

        // #region PopUps

        function openWeightings() {
            try {
                $('#WeightingsPopUp').modal('show');
                GetInherentWeights();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openWeightings() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetRfThresholdRules() {
            try {
                $('#ThresholdsPopUp').modal('show');
                $('#tblThresholdQuan').hide();
                $('#tblThreshold').hide();
                if (AMLRaViewModel.Type() === 'A' || AMLRaViewModel.Type() === 'O') {
                    // FOR QUAL ALL TYPES AND QUAN AREAS
                    GetQualThresholdData();
                } else if (AMLRaViewModel.ClickedRiskAreaType() === 'QTDR' && AMLRaViewModel.Type() != 'A') {
                    // FOR QUAN FACTORS
                    GetThresholdData();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetRfThresholdRules() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetThresholdData() {
            try {
                var tableId = 0;
                if (AMLRaViewModel.Type() === 'A') {
                    tableId = AMLRaViewModel.ClickedRiskAreaId();
                }
                else if (AMLRaViewModel.Type() === 'F') {
                    tableId = AMLRaViewModel.ClickedRiskFactor();
                }
                $.ajax({
                    url: "/api/WeightingsThresholds/GetFactorThreshold?TableId=" + tableId + "&AssessmentType=" + AMLRaViewModel.AssessmentTypeId() +
                        "&TableType=" + AMLRaViewModel.Type() + "&SurveyCategoryId=" + AMLRaViewModel.SelectedSurveyComponentId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetThresholdData() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {

                        $('#NoDataErrorThresholds').hide();

                        var MappedThresholdValue = $.map(jsonResult, function (result) {
                            return new ThresholdValueModel(result);
                        });
                        $('#tblThresholdQuan tbody tr').remove();
                        AMLRaViewModel.ThresholdValuesList(MappedThresholdValue);

                        if (AMLRaViewModel.ThresholdValuesList()[0] != undefined)
                            AMLRaViewModel.ThresholdChildList(AMLRaViewModel.ThresholdValuesList()[0].ChildList());

                        $('#tblThresholdQuan').show();
                    }

                    else {
                        if (jsonResult.length == 0 || jsonResult == 0 || jsonResult == null || jsonResult == undefined) {
                            $('#NoDataErrorThresholds').show();
                        }
                        else {
                            $('#NoDataErrorThresholds').show();
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdData() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetThresholdData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetQualThresholdData() {
            try {
                var tableId = 0;
                if (AMLRaViewModel.Type() === 'A' || AMLRaViewModel.Type() === 'O') {
                    tableId = AMLRaViewModel.ClickedRiskAreaId();
                }
                else if (AMLRaViewModel.Type() === 'F') {
                    tableId = AMLRaViewModel.ClickedRiskFactor();
                }

                $.ajax({
                    url: "/api/WeightingsThresholds/GetQualFactorThreshold",
                    data: {
                        "TableId": tableId, "AssessmentType": AMLRaViewModel.AssessmentTypeId(), "TableType": "A", "SurveyCategoryId": AMLRaViewModel.SelectedSurveyComponentId()
                    },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {

                        $('#NoDataErrorQualThresholds').hide();
                        var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                            return new QualThresholdValueModel(result);
                        });
                        $('#tblThreshold tbody tr').remove();
                        AMLRaViewModel.QualThresholdValuesList(MappedQualThresholdValue);

                        $('#tblThreshold').show();
                    }
                    else {
                        if (jsonResult.length == 0 || jsonResult == 0 || jsonResult == null || jsonResult == undefined) {
                            $('#NoDataErrorQualThresholds').show();
                        }
                        else {
                            $('#NoDataErrorQualThresholds').show();

                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ThresholdValueModel(item) {
            try {
                var self = this;
                self.IrlId = ko.observable(item.IrlId);
                self.IrlName = ko.observable(item.IrlName);
                var MappedChild = $.map(item.Child, function (result) {
                    return new ThresholdChildModel(result);
                });
                self.ChildList = ko.observableArray(MappedChild);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ThresholdValueModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ThresholdChildModel(item) {
            try {
                var self = this;
                self.RiskLevelId = ko.observable(item.RiskLevelId);
                self.RiskLevelName = ko.observable(item.RiskLevelName);
                self.RiskLevelCss = ko.observable(item.RiskLevelCss);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ThresholdChildModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function QualThresholdValueModel(item) {
            try {
                var self = this;
                self.Uid = ko.observable(item.Uid);
                self.FinalRiskId = ko.observable(item.FinalRiskId);
                self.Min = ko.observable(item.Min);
                self.Max = ko.observable(item.Max);
                self.ValidationMessage = ko.observable(null);
                self.ShouldShowMessage = ko.observable(false);
                self.ValidationMessageMin = ko.observable(null);
                self.ShouldShowMessageMin = ko.observable(false);
                self.Description = ko.observable($('<div/>').html(item.Description).text());
                //self.CSS = ko.observable($('<div/>').html(item.CSS).text());
                self.CSS = ko.observable(item.Css);
                self.Level = ko.observable(item.Level);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QualThresholdValueModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetInherentWeights() {
            try {
                AMLRaViewModel.WTBusinessUnits([]);
                AMLRaViewModel.AreasOrQuestions([]);
                AMLRaViewModel.inherentWeight([]);
                var tableId = 0;
                if (AMLRaViewModel.Type() === 'A' || AMLRaViewModel.Type() === 'O') {
                    tableId = AMLRaViewModel.ClickedRiskAreaId();
                }
                else if (AMLRaViewModel.Type() === 'F') {
                    tableId = AMLRaViewModel.ClickedRiskFactor();
                }
                var type = AMLRaViewModel.Type();
                if (AMLRaViewModel.Type() == 'O')
                    type = 'A';

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/GetInherentWeights",
                    type: "GET",
                    headers: headers,
                    data: {
                        "AssessmentType": AMLRaViewModel.AssessmentTypeId(), "SurveyCategoryId": AMLRaViewModel.SelectedSurveyComponentId().toString(), "AreaId": tableId, "OrgLevel": 0,
                        "NodeType": type
                    }
                })
                    .success((jsonResult, success) => {
                        try {
                            if (jsonResult.Incident_Description == null) {
                                AMLRaViewModel.WTBusinessUnits([]);
                                AMLRaViewModel.AreasOrQuestions([]);
                                AMLRaViewModel.inherentWeight([]);
                                AMLRaViewModel.decimalLimit('');
                                AMLRaViewModel.decimalLimit(jsonResult.precisionObject);

                                // Map Business Units.
                                if (jsonResult.BUWiseWeightings.length > 0) {
                                    var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                        return new WTBusinessLevelsModel(result);
                                    });
                                    AMLRaViewModel.WTBusinessUnits([]);
                                    AMLRaViewModel.WTBusinessUnits(mappedBusinessUnitData);

                                }
                                AMLRaViewModel.totalValidityFlag(1);
                                for (var i = 0; i < AMLRaViewModel.WTBusinessUnits().length; i++) {
                                    if (AMLRaViewModel.WTBusinessUnits()[i].total() == 100.00000 || AMLRaViewModel.WTBusinessUnits()[i].total() == 0.00000) {
                                        AMLRaViewModel.totalValidityFlag(1);
                                    }
                                    else {
                                        AMLRaViewModel.totalValidityFlag(0);
                                        break;
                                    }
                                }
                                AMLRaViewModel.AreasOrQuestions([]);
                                if (jsonResult.AreaWiseWeightings.length > 0) {
                                    var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                        return new RiskAreaModel(result);
                                    });
                                    AMLRaViewModel.AreasOrQuestions([]);
                                    AMLRaViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                }
                                AMLRaViewModel.inherentWeight([]);
                                if (jsonResult.WeightingsList.length > 0) {
                                    var mappedControlsWeight = $.map(jsonResult.WeightingsList, (result) => {
                                        return new WeightingsModel(result);
                                    });
                                    AMLRaViewModel.inherentWeight([]);
                                    AMLRaViewModel.inherentWeight(mappedControlsWeight);
                                }

                                $('#WeightingsTableRA tbody').scroll(function (e) { //detect a scroll event on the tbody
                                    $('#WeightingsTableRA thead').css("left", -$("#WeightingsTableRA tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                    $('#WeightingsTableRA thead th:nth-child(1)').css("left", $("#WeightingsTableRA tbody").scrollLeft()); //fix the first cell of the header
                                    $('#WeightingsTableRA tbody td:nth-child(1)').css("left", $("#WeightingsTableRA tbody").scrollLeft()); //fix the first column of tdbody
                                });
                            }
                            else {
                                if (jsonResult == null || jsonResult == undefined) {

                                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
                                }
                                else {
                                    var msg = 'An error occurred. Please contact your Application Administrator.';
                                    logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                                }
                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() Success method in AmlInherentRiskAssessment.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in AmlInherentRiskAssessment.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function WTBusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.BUWeightings.length; ++p) {
                        total += Number(Number(self.BUWeightings[p].WeightingValue()).toFixed(AMLRaViewModel.decimalLimit()));
                    }
                    return total.toFixed(AMLRaViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WTBusinessLevelsModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function RiskAreaModel(item) {
            try {
                var self = this;
                if (item.QuestionType == null) {
                    self.QuestionType = '';
                }
                else
                    self.QuestionType = item.QuestionType;

                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.selectedBuWeight = ko.observable(0);
                self.selectedBuWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && newVal >= 0.00000 && newVal <= 100.00000) {
                        var total = 0;
                        for (var i = 0; i < AMLRaViewModel.AreasOrQuestions().length; i++) {
                            total += Number(Number(AMLRaViewModel.AreasOrQuestions()[i].selectedBuWeight()));
                        }
                        AMLRaViewModel.EditableBusinessunitTotal(total.toFixed(AMLRaViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (newVal < 0.00000 || newVal > 100.00000)) {
                        this.selectedBuWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(AMLRaViewModel), true);
                    }
                    else {
                        this.selectedBuWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(AMLRaViewModel), true);
                    }
                }, this);

                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function showQualResponseCommentsPopUp(data, event) {
            try {
                $('#QualResponseCommentsPopUp').modal('show');
                $('#QualCommentsMain').hide();
                GetQualResponseComments(data);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source showQualResponseCommentsPopUp() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

        }

        function ShowComments(businessUnitId) {
            try {
                $('#OverrideCommentsPopUp').modal('show');
                $('#CommentsMain').hide();
                GetOverrideComments(businessUnitId);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowComments() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region Models

        function RiskFactorModel(item) {
            try {
                var self = this;
                self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
                self.RiskFactorId = ko.observable(item.RiskFactorId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
                self.Type = ko.observable($('<div/>').html(item.TabType).text());
                self.TargetRow = ko.observable();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        };

        function QuanColumnTypeModel(item) {
            try {
                var self = this;
                self.COL_ID = ko.observable($('<div/>').html(item.COL_ID).text());
                self.COL_DISPLAY_NAME = ko.observable($('<div/>').html(item.COL_DISPLAY_NAME).text());
                self.COL_TYPE = ko.observable($('<div/>').html(item.COL_TYPE).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuanColumnTypeModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //this model captures businessunits
        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //this model captures businessunits to remap
        function BusinessUnitModelDUP(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
                self.SubLevelId = ko.observable(item.SubLevelId());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModelDUP() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ResponseCommentsModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
            }
            catch (e) {
                var msg = 'exception' + e + 'source: ResponseCommentsModel() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function OverrideCommentModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.UploadRole = ko.observable($('<div/>').html(item.UploadRole).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
                self.FullName = ko.computed(function () {
                    return item.UploadedBy + " (" + $('<div/>').html(item.UploadRole).text() + ")";
                });
            }
            catch (e) {
                var msg = 'exception' + e + 'source: OverrideCommentModel() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function QuantitativeResponseColumnsModel(item) {
            try {
                var self = this;
                self.Rank = ko.observable(item.Rank);
                self.ResponseId = ko.observable(item.ResponseId);
                self.ResponseType = ko.observable(item.ResponseType);
                self.response = ko.observable(item.response);
                self.description = ko.observable(item.description);
                self.calculationapplicability = ko.observable(item.calculationapplicability);
                self.currencyapplicability = ko.observable(item.currencyapplicability);
                self.weightings = ko.observable(item.weightings);
                self.SimpleAverageflag = ko.observable(item.SimpleAverageflag);
                self.isGlobalFlag = ko.observable(item.isGlobalFlag);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseColumnsModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlId = ko.observable(item.BlId)
                var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                    return new BuLevelValueListModel(result);
                });
                self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SubFactorDataListModel(item) {
            try {
                var self = this;
                self.SubFactorId = ko.observable($('<div/>').html(item.SubFactorId).text());
                if (AMLRaViewModel.ClickedRiskAreaType() == 'QUAL')
                    self.SubFactorName = ko.observable($('<div/>').html(item.RiskSubfactorShortName).text());
                else
                    self.SubFactorName = ko.observable($('<div/>').html(item.SubFactorName).text());

                self.Rank = ko.observable($('<div/>').html(item.Rank).text());
                self.RowColorQues = ko.observable($('<div/>').html(item.RowColor).text());
                if (item.AMLRiskLevel != undefined && item.AMLRiskLevel != "") {
                    var newreplacedtooltip = $('<div/>').html(item.AMLRiskLevel.replace(/, /g, '&#013')).text();
                    self.AMLRiskLevel = ko.observable($('<div/>').html(newreplacedtooltip).text());
                }
                else {
                    self.AMLRiskLevel = ko.observable($('<div/>').html(item.AMLRiskLevel).text());
                }
                self.Colour = ko.observable(item.Colour);
                var MappedObject = $.map(item.BusinessUnitCountList, function (result) {
                    return new BUCountListModel(result);
                });
                self.BusinessUnitCountList = MappedObject;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BUCountListModel(item) {
            try {
                var self = this;
                var MappedObject = $.map(item.ResponseList, function (result) {
                    return new RiskLevelModel(result);
                });
                self.ResponseList = MappedObject;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function RiskLevelModel(item) {
            try {
                var self = this;
                if (item.RiskLevelText != undefined && item.RiskLevelText != '')
                    self.RiskLevelText = ko.observable($('<div/>').html(item.RiskLevelText).text());
                else
                    self.RiskLevelText = "";

                self.Response_BUId = ko.observable($('<div/>').html(item.Response_BUId).text());
                self.SubFactorId = ko.observable($('<div/>').html(item.SubFactorId).text());
                self.RowColor = ko.observable($('<div/>').html(item.RowColor).text());
                self.ResponseId = ko.observable($('<div/>').html(item.ResponseId).text());
                self.Responsevalue = ko.observable($('<div/>').html(item.Responsevalue).text());
                self.HeatMapDescription = ko.observable($('<div/>').html(item.HeatMapDescription).text());
                self.HeatMapDescriptionTitle = ko.observable($('<div/>').html(item.HeatMapDescription).text());
                if (AMLRaViewModel.ClickedRiskAreaType() == 'QUAN') {
                    if (AMLRaViewModel.Type() === 'A') { self.Responsevalue = ko.observable($('<div/>').html(item.Responsevalue).text()); } else {
                        var value = (item.Responsevalue);
                        if (value == "-") {
                            var ChangedValue = value;
                            self.Responsevalue = ko.observable("-");
                            self.DefaultValue = ko.observable("-");
                            self.BillionValue = ko.observable("-");
                            self.thousandsvalue = ko.observable("-");
                            self.MillionValue = ko.observable("-");
                        }
                        else {
                            var ChangedValue = parseInt(value).toLocaleString('en-US', { style: 'decimal' }).replace(/[$]/g, '');
                            self.Responsevalue = ko.observable(ChangedValue);
                            self.DefaultValue = ko.observable(ChangedValue);
                            self.BillionValue = ko.observable(parseInt(value / 1000000000, 000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, ''));
                            self.thousandsvalue = ko.observable(parseInt(value / 1000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, ''));
                            self.MillionValue = ko.observable(parseInt(value / 1000000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, ''));
                        }
                    }
                }

                if (AMLRaViewModel.ClickedRiskAreaType() == 'QUAL') {
                    if (item.Responsevalue != undefined && item.Responsevalue.length > 21) {

                        var value = item.Responsevalue.substring(0, 20) + '...';
                        self.Responsevalue = ko.observable($('<div/>').html(value).text());

                        self.HeatMapDescriptionTitle = ko.observable($('<div/>').html('Heatmap: ' + item.HeatMapDescription + '&#013' + 'Response: ' + item.Responsevalue).text());

                    }
                }
                self.ResponsevalueTitle = ko.observable($('<div/>').html(item.Responsevalue).text());

                self.HeatMapCss = ko.observable($('<div/>').html(item.HeatMapCss).text());

                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                //logic is reverse to bind html in opp 
                if (item.Applicability == 0)
                    self.Applicability = ko.observable(true);
                else
                    self.Applicability = ko.observable(false);

            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ColumnwiseriskListModel(item) {
            try {
                var self = this;
                self.Css = ko.observable($('<div/>').html(item.RiskLevelCss).text());
                self.RiskLevelText = ko.observable($('<div/>').html(item.RiskLevelText).text());
                self.ResponseId = ko.observable($('<div/>').html(item.ResponseId).text());
                self.Responsevalue = ko.observable($('<div/>').html(item.Responsevalue).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ColumnwiseriskListModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function CalculatedBottomLevelModel(item) {
            try {

                var self = this;
                self.BuId = ko.observable($('<div/>').html(item.BuId).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.CalculatedRiskLevel = ko.observable($('<div/>').html(item.CalculatedRiskLevel).text());
                self.CalculatedRiskLevelCss = ko.observable($('<div/>').html(item.CalculatedRiskLevelCss).text());
                self.ShowOverAllScoreFlag = ko.observable(item.ShowOverAllScoreFlag);
                if (AMLRaViewModel.Type() == 'A')
                    AMLRaViewModel.ShowOverAllScoreFlag(parseInt(item.ShowOverAllScoreFlag));
                else
                    AMLRaViewModel.ShowOverAllScoreFlag(0);

                if (item.OverAllCalculatedRiskLevelCss == undefined)
                    self.OACalculatedRiskLevelCss = ko.observable("");
                else
                    self.OACalculatedRiskLevelCss = ko.observable(item.OverAllCalculatedRiskLevelCss);

                if (item.OverAllCalculatedRiskLevel == undefined)
                    self.OACalculatedRiskLevel = ko.observable("");
                else
                    self.OACalculatedRiskLevel = ko.observable(item.OverAllCalculatedRiskLevel);

                self.FinalRiskLevel = ko.observable($('<div/>').html(item.FinalRiskLevel).text());
                self.FinalRiskLevelCss = ko.observable($('<div/>').html(item.FinalRiskLevelCss).text());
                self.ComplianceRIskLevel = ko.observable($('<div/>').html(item.ComplianceRIskLevel).text());
                self.ComplianceRIskLevelCss = ko.observable($('<div/>').html(item.ComplianceRIskLevelCss).text());
                self.Weight = ko.observable($('<div/>').html(item.Weight).text());
                self.Weight = ko.observable($('<div/>').html(item.Weight).text());
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: CalculatedBottomLevelModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SubFactorDataModel(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ResponseId);
                self.Responsevalue = ko.observable($('<div/>').html(item.Responsevalue).text());
                var value = (item.Responsevalue);
                if (value == "-") {
                    var ChangedValue = value;
                    self.Responsevalue = ko.observable("-");
                    self.DefaultValue = ko.observable("-");
                    self.BillionValue = ko.observable("-");
                    self.thousandsvalue = ko.observable("-");
                    self.MillionValue = ko.observable("-");
                }
                else {
                    var ChangedValue = parseInt(value).toLocaleString('en-US', { style: 'decimal' }).replace(/[$]/g, '');
                    self.Responsevalue = ko.observable(ChangedValue);
                    self.DefaultValue = ko.observable(ChangedValue);
                    self.BillionValue = ko.observable(parseInt(value / 1000000000, 000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, ''));
                    self.thousandsvalue = ko.observable(parseInt(value / 1000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, ''));
                    self.MillionValue = ko.observable(parseInt(value / 1000000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, ''));
                }

                self.SubFactorName = ko.observable($('<div/>').html(item.SubFactorName).text());
                self.BuId = ko.observable(item.BuId);
                self.SubFactorId = ko.observable(item.SubFactorId);
                self.SubFactorRank = ko.observable(item.SubFactorRank);
                self.IsCurrency = ko.observable(item.IsCurrency);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region Filter Methods

        function openSideNav() {
            try {
                $('#myValueDropdown').removeClass('show')
                $('#myValueDropdownSort').removeClass('open');
                $('#myDropdown').removeClass('show')
                $('#myDropdownSort').removeClass('open')
                $('#exportDropdown').removeClass('show')
                $('#exportDropdownBtn').removeClass('open')

                if ($('#BusinessUnitFilterBtn').hasClass("openFilter")) {
                    closeSideNav();
                } else {
                    $('#BusinessUnitFilterBtn').addClass("openFilter");
                    $('#OrgFilterError').hide();
                    $('#BUFilterError').hide();
                    $('#OrganizationalLevel').show();
                    $('#BuselectFilter').show();
                    $('#FilterButton').show();
                    if (AMLRaViewModel.FiltersListFlag() == false) {
                        GetAllOrganizationalLevels();
                    }
                }
                AMLRaViewModel.IsSideNavOpen(1);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openSideNav() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function closeSideNav() {
            try {
                $('#BusinessUnitFilterBtn').removeClass("openFilter");
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                AMLRaViewModel.IsSideNavOpen(0);
                $('#OrganizationalLevel').hide();
                $('#BuselectFilter').hide();
                $('#FilterButton').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BindHTML() {
            try {
                //Org Level Filter Fossil style
                var OrgList = "";

                OrgList += '<div class="filter-nav1"><ul class="nav nav-tabs"><li class="fl-lbl"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters") == -1 )? "Add Filters": $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters")].Name"></span> </li>';

                for (var i = 0; i < AMLRaViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<li class="active"><a href="#tab_' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                    } else {
                        OrgList += '<li class=""><a href="#tab_' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true" ></i> </a></li>'
                    }
                }
                OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + AMLRaViewModel.BUTitle() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'

                OrgList += '</ul><div class="tab-content filter-content">';

                for (var i = 0; i < AMLRaViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<div class="tab-pane active" id="tab_' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    } else {
                        OrgList += '<div class="tab-pane" id="tab_' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    }

                    if (AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                        for (var j = 0; j < AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                            OrgList += '<label  class="ft-selection"><input id=sublevel' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;"><i class="fa fa-check ' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i><span class="cc-facet-result-text tag-text">' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span></label>';
                        }

                    }
                    OrgList += '</div>';
                }
                OrgList += '<div class="tab-pane" id="tab_BU">';

                AMLRaViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return AMLRaViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });

                AMLRaViewModel.BusinessUnitListForFilters(AMLRaViewModel.DistinctFileredBUs());

                for (var w = 0; w < AMLRaViewModel.BusinessUnitListForFilters().length; w++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelBU' + AMLRaViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                        '<i class="fa fa-check ' + AMLRaViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + AMLRaViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
                        '</label>';
                }
                OrgList += '</div>';

                if (OrgList == "") {
                    OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">Organizational Levels are not configured for this Year of Assessment.</label></div>';

                }
                document.getElementById('OrganizationalLevel').innerHTML = OrgList;

                for (var i = 0; i < AMLRaViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var l = 0; l < AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                        ko.applyBindingsToNode($('#sublevel' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: AMLRaViewModel.SubCheckboxSelected } }, AMLRaViewModel);
                    }
                }

                for (var k = 0; k < AMLRaViewModel.BusinessUnitListForFilters().length; k++) {
                    ko.applyBindingsToNode($('#sublevelBU' + AMLRaViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: AMLRaViewModel.SubCheckboxSelected } }, AMLRaViewModel);
                }
                AMLRaViewModel.NumberOfBUsSelectedRA(AMLRaViewModel.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BindHTML function in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SubCheckboxSelected(data, event) {
            try {
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
                var BUselected = "";
                var sideNavHeight = "33vh";
                var sideNavMarginTop = "0rem";

                if (isNaN(parseInt(selectedSubOrgLevelID)) && AMLRaViewModel.SelectedCheckedList().length > 0) {
                    $('#BUFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && AMLRaViewModel.SelectedCheckedBUList().length > 0) {
                    $('#OrgFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && AMLRaViewModel.SelectedCheckedBUList().length == 0) {
                    for (var i = 0; i < AMLRaViewModel.OrgLvlDrpDwnList().length; i++) {
                        var counterCheck = 0;
                        for (var g = 0; g < AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            if (AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                                if (event.currentTarget.checked) {
                                    $("#sublevel" + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                    AMLRaViewModel.SelectedCheckedList.push({
                                        SubLevelId: AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                        SubLevelName: AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                        OrgLevelName: AMLRaViewModel.OrgLvlDrpDwnList()[i].BlName()
                                    });
                                }
                                else {
                                    $("#sublevel" + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                    $('.fa-check.' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                    if (AMLRaViewModel.SelectedCheckedList().length > 0) {
                                        AMLRaViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                    }
                                }
                            }

                            //Mark parent check box as checked if all sub levels are selected
                            if ($("#sublevel" + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                                counterCheck++;
                            }
                            if (counterCheck > 0 && counterCheck == AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                            }
                            else if (counterCheck > 0 && counterCheck == AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + AMLRaViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                            }
                        }
                    }
                    //Logic to re-set the BU list
                    AMLRaViewModel.BusinessUnitListForFilters([]);
                    if (AMLRaViewModel.SelectedCheckedList().length > 0) {
                        var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < AMLRaViewModel.SelectedCheckedList().length; m++) {
                                if (result.SubLevelId() == AMLRaViewModel.SelectedCheckedList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                        //Main tain this list to retain the org filters on deselection of applicability filters
                        AMLRaViewModel.FinalOrgFilterList(mappedBuList);

                    }
                    else {
                        AMLRaViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                        AMLRaViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    //document.getElementById("sideNav").style.height = sideNavHeight;
                    //document.getElementById("RaTab").style.marginTop = sideNavMarginTop;
                    SetFilterSelection();

                } else if (isNaN(parseInt(selectedSubOrgLevelID)) && AMLRaViewModel.SelectedCheckedList().length == 0) {
                    BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                    for (var i = 0; i < AMLRaViewModel.BusinessUnitListForFiltersDUP().length; i++) {
                        if (AMLRaViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitId() == BUselected) {
                            if (event.currentTarget.checked) {
                                $("#sublevelBU" + BUselected).prop("checked", true);
                                $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                                AMLRaViewModel.SelectedCheckedBUList.push({
                                    SubLevelId: AMLRaViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitId(),
                                    SubLevelName: AMLRaViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitName()
                                });
                            }
                            else {
                                $("#sublevelBU" + BUselected).prop("checked", false);
                                $('.fa-check.' + BUselected).css({ 'display': 'none' });
                                if (AMLRaViewModel.SelectedCheckedBUList().length > 0) {
                                    AMLRaViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == AMLRaViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitId() })
                                }
                            }
                            break;
                        }
                    }

                    if (AMLRaViewModel.SelectedCheckedBUList().length > 0) {
                        //Logic to re-set the BU list
                        AMLRaViewModel.BusinessUnitListForFilters([]);

                        var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < AMLRaViewModel.SelectedCheckedBUList().length; m++) {
                                if (result.BusinessUnitId() == AMLRaViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                    }
                    else {
                        AMLRaViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                        AMLRaViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetBUFilterSelection();
                }
                //Set count of BU's selected
                if (AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                    AMLRaViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return AMLRaViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(AMLRaViewModel.DistinctFileredBUs());
                }

                AMLRaViewModel.NumberOfBUsSelectedRA(AMLRaViewModel.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'inline-block' });
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:  SubCheckboxSelected function in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SetFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                //Mark Org levels filter seletion
                var contentHtml = "";
                for (var k = 0; k < AMLRaViewModel.SelectedCheckedList().length; k++) {
                    contentHtml += '<div id="DynamicOptedFilters_' + AMLRaViewModel.SelectedCheckedList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">' + AMLRaViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + AMLRaViewModel.SelectedCheckedList()[k].SubLevelName + '<span id="ClearFilterText_' + AMLRaViewModel.SelectedCheckedList()[k].SubLevelId + '" class="font-weight-bold bg-transparent mb-2" data-bind="click:ClearOrgFilterSelection"><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }
                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < AMLRaViewModel.SelectedCheckedList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterText_' + AMLRaViewModel.SelectedCheckedList()[k].SubLevelId), { click: AMLRaViewModel.ClearOrgFilterSelection }, AMLRaViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ClearOrgFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);;

                document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (AMLRaViewModel.SelectedCheckedList().length > 0) {
                    AMLRaViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                AMLRaViewModel.BusinessUnitListForFilters([]);
                if (AMLRaViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < AMLRaViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == AMLRaViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    AMLRaViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    AMLRaViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);
                    AMLRaViewModel.FinalOrgFilterList(mappedBuList);
                    $('#BUFilterError').hide();
                }
                //Set count of BU's selected
                if (AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                    AMLRaViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return AMLRaViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(AMLRaViewModel.DistinctFileredBUs());
                }

                AMLRaViewModel.NumberOfBUsSelectedRA(AMLRaViewModel.BusinessUnitListForFilters().length)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SetBUFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < AMLRaViewModel.SelectedCheckedBUList().length; k++) {
                    contentHtml += '<div id="DynamicBUOptedFilters_' + AMLRaViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">BU </span> : ' + AMLRaViewModel.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + AMLRaViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="font-weight-bold bg-transparent mb-2" data-bind="click:ClearBUFilterSelection"><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }

                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < AMLRaViewModel.SelectedCheckedBUList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextBU_' + AMLRaViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: AMLRaViewModel.ClearBUFilterSelection }, AMLRaViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ClearBUFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (AMLRaViewModel.SelectedCheckedBUList().length > 0) {
                    AMLRaViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                AMLRaViewModel.BusinessUnitListForFilters([]);
                if (AMLRaViewModel.SelectedCheckedBUList().length > 0) {
                    var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < AMLRaViewModel.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == AMLRaViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);

                }
                else {
                    AMLRaViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(AMLRaViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(mappedBuList);

                    $('#OrgFilterError').hide();
                }
                //Set count of BU's selected
                if (AMLRaViewModel.BusinessUnitListForFilters().length > 0) {
                    AMLRaViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return AMLRaViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    AMLRaViewModel.BusinessUnitListForFilters(AMLRaViewModel.DistinctFileredBUs());
                }
                AMLRaViewModel.NumberOfBUsSelectedRA(AMLRaViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //Apply filter event
        function ApplyBuFitlers(data, event) {
            try {
                AMLRaViewModel.BUFiltersApplied(true);
                if (AMLRaViewModel.ClickedRiskAreaType() == "QUAL") {
                    $("#QualInnerGrid").hide();
                    $("#QualOverallGrid").hide();
                    $('#RiskLevelTabinnerDiv').hide();
                    $('#RiskLevelInnerTabDivforHeatmap').hide();
                    $('#factorstab').hide();
                    $('#CurrencyDropDown').hide();
                    $('#ThresholdsBtn').hide();
                    $('#NoFactorsError').hide();
                    $('#NoSubFactorsError').hide();

                    GetAllQualitativeData();
                }
                else {
                    $('#QuanAreaGrid').hide();
                    $('#QuanFactorGrid').hide();
                    GetAllQuantitativeData();
                }

                closeSideNav();
                AMLRaViewModel.NumberOfBUsSelectedRA(AMLRaViewModel.BusinessUnitListForFilters().length)
                $('.badge').css({ 'display': 'inline-block' });
                $("#f-filter").css("display", "");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ApplyBuFitlers() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //clear filter event
        function ClearAllBuFitlers(data, event) {
            try {
                AMLRaViewModel.BUFiltersApplied(false);
                for (var i = 0; i < AMLRaViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var g = 0; g < AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                        $("#sublevel" + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                        $('.fa-check.' + AMLRaViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                    }
                }
                for (var g = 0; g < AMLRaViewModel.BusinessUnitListForFiltersDUP().length; g++) {
                    $("#sublevel" + AMLRaViewModel.BusinessUnitListForFiltersDUP()[g].BusinessUnitId()).prop("checked", false);
                    $('.fa-check.' + AMLRaViewModel.BusinessUnitListForFiltersDUP()[g].BusinessUnitId()).css({ 'display': 'none' });
                }

                if (AMLRaViewModel.ClickedRiskAreaType() != 'QUAL') {
                    $('#QuanAreaGrid').hide();
                    $('#QuanFactorGrid').hide();

                    AMLRaViewModel.BusinessUnitListForFilters([]);
                    GetAllQuantitativeData();
                    AMLRaViewModel.SelectedCheckedBUList([]);
                    AMLRaViewModel.SelectedCheckedList([]);
                    closeSideNav();
                    AMLRaViewModel.NumberOfBUsSelectedRA(0);
                }
                else if (AMLRaViewModel.ClickedRiskAreaType() == 'QUAL') {
                    $("#QualInnerGrid").hide();
                    $("#QualOverallGrid").hide();
                    closeSideNav();
                    AMLRaViewModel.NumberOfBUsSelectedRA(0);
                    AMLRaViewModel.SelectedType('QUAL');

                    AMLRaViewModel.BusinessUnitListForFilters([]);
                    GetAllQualitativeData();

                    $('#RiskLevelTabinnerDiv').hide();
                    $('#RiskLevelInnerTabDivforHeatmap').hide();
                    $('#factorstab').hide();
                    $('#CurrencyDropDown').hide();
                    $('#FactorReportDownload').hide();
                    $('#WeightingsBtnQuan').hide();
                    $('#ThresholdsBtn').hide();
                    AMLRaViewModel.RiskFactorList([])
                    $('#NoFactorsError').hide();
                    $('#NoSubFactorsError').hide();
                    AMLRaViewModel.ClickedRiskAreaType('QUAL');
                }
                $('.badge').css({ 'display': 'none' });
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                $('#DynamicOrgOptedFilters').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAllBuFitlers() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region Toggles

        function HeatmapToggle(data, event) {
            try {
                if ($("#HeatmapToggleeventQualRA").is(':checked')) {
                    AMLRaViewModel.HeatmapFlag(true);
                }
                else {
                    AMLRaViewModel.HeatmapFlag(false);
                }
            }
            catch (e) {
                var msg = 'exception' + e + ' HeatmapToggle() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }


        function UpdateDistributionData() {
            try {

                if (AMLRaViewModel.Type() === 'F') {
                    $('#tblRAQuan tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAQuan thead').css("left", -$("#tblRAQuan tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAQuan thead th:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAQuan tbody td:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first column of tdbody
                    });
                } else if (AMLRaViewModel.Type() === 'A') {
                    $('#tblRAQuanOverAllQ tbody').scroll(function (e) { //detect a scroll event on the tbody
                        /*
                        Setting the thead left value to the negative valule of tbody.scrollLeft will make it track the movement
                        of the tbody element. Setting an elements left value to that of the tbody.scrollLeft left makes it maintain it's relative position at the left of the table.    
                        */
                        $('#tblRAQuanOverAllQ thead').css("left", -$("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAQuanOverAllQ thead th:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAQuanOverAllQ tbody td:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first column of tdbody
                        $('#tblRAQuanOverAllQ tbody th:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first column of tdbody

                    });
                }
                if (AMLRaViewModel.Query() != "") {
                    SearchResult();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateDistributionData() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region Event Clicks and Methods

        function FormatValueData(data, event) {
            $('#myDropdown').removeClass('show');
            $('#myDropdownSort').removeClass('open');
            closeSideNav();
            document.getElementById("myValueDropdown").classList.toggle("show");
            document.getElementById("myValueDropdownSort").classList.toggle("open");
            $('#exportDropdown').removeClass('show')
            $('#exportDropdownBtn').removeClass('open')
        }

        function DisplayExportDropdown(data, event) {
            $('#myDropdown').removeClass('show');
            $('#myDropdownSort').removeClass('open');
            $('#myValueDropdown').removeClass('show')
            $('#myValueDropdownSort').removeClass('open')
            closeSideNav();
            document.getElementById("exportDropdown").classList.toggle("show");
            document.getElementById("exportDropdownBtn").classList.toggle("open");
        }

        function HideallValueDivs() {
            $('#MillionCR').hide();
            $("#BillionCR").hide();
            $("#ThousandsCR").hide();
        }

        function valuechange(data, event) {
            try {

                HideallValueDivs();
                var selectedValue = event.currentTarget.id;
                // var selectedValue = document.getElementById("CurrencyDropDown").value;

                if (selectedValue != "Resettodefault")
                    $('#' + selectedValue + 'CR').show();

                $("#Currencybadge").show();
                for (var f = 0; f < AMLRaViewModel.TotalSubFactorDataList().length; f++) {
                    if (AMLRaViewModel.TotalSubFactorDataList()[f].IsCurrency() == 1) {
                        if (selectedValue == "Million") {
                            AMLRaViewModel.CurrencyTypeSelected('M');
                            AMLRaViewModel.CurrencyNameSelected("Million");
                            AMLRaViewModel.TotalSubFactorDataList()[f].Responsevalue(AMLRaViewModel.TotalSubFactorDataList()[f].MillionValue())
                        }
                        else if (selectedValue == "Thousands") {
                            AMLRaViewModel.CurrencyTypeSelected('T');
                            AMLRaViewModel.CurrencyNameSelected("Thousands");
                            AMLRaViewModel.TotalSubFactorDataList()[f].Responsevalue(AMLRaViewModel.TotalSubFactorDataList()[f].thousandsvalue())
                        }
                        else if (selectedValue == "Billion") {
                            AMLRaViewModel.CurrencyTypeSelected('B');
                            AMLRaViewModel.CurrencyNameSelected("Billion");
                            AMLRaViewModel.TotalSubFactorDataList()[f].Responsevalue(AMLRaViewModel.TotalSubFactorDataList()[f].BillionValue())
                        }
                        else {
                            $("#Currencybadge").hide();
                            AMLRaViewModel.CurrencyTypeSelected('');
                            AMLRaViewModel.CurrencyNameSelected("Default");
                            AMLRaViewModel.TotalSubFactorDataList()[f].Responsevalue(AMLRaViewModel.TotalSubFactorDataList()[f].DefaultValue())
                        }
                    }
                }

                for (var f = 0; f < AMLRaViewModel.SubFactorGridDataListCur().length; f++) {
                    for (var i = 0; i < AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList.length; i++) {

                        for (var r = 0; r < AMLRaViewModel.editableResponseType().length; r++) {
                            if (AMLRaViewModel.editableResponseType()[r].currencyapplicability() == true) {

                                for (var j = 0; j < AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList.length; j++) {

                                    if (AMLRaViewModel.editableResponseType()[r].ResponseId() == AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList[j].ResponseId) {
                                        var defaultVal = AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList[j].DefaultResponsevalue;
                                        if (selectedValue == "Million") {
                                            AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList[j].Responsevalue = MillionValue(defaultVal);
                                        }
                                        else if (selectedValue == "Thousands") {
                                            AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList[j].Responsevalue = thousandsvalue(defaultVal);
                                        }
                                        else if (selectedValue == "Billion") {
                                            AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList[j].Responsevalue = BillionValue(defaultVal);
                                        }
                                        else {
                                            AMLRaViewModel.SubFactorGridDataListCur()[f].BusinessUnitCountList[i].ResponseList[j].Responsevalue = defaultVal;
                                        }
                                    }
                                }
                            }
                        }

                    }
                }

                AMLRaViewModel.SubFactorGridDataList([]);
                AMLRaViewModel.SubFactorGridDataList(AMLRaViewModel.SubFactorGridDataListCur());
                $('#tblRAQuan tbody').scroll(function (e) { //detect a scroll event on the tbody
                    $('#tblRAQuan thead').css("left", -$("#tblRAQuan tbody").scrollLeft()); //fix the thead relative to the body scrolling
                    $('#tblRAQuan thead th:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first cell of the header
                    $('#tblRAQuan tbody td:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first column of tdbody
                });
                $('.nav-link').removeClass('active');
                $("#" + selectedValue).addClass('active');

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: valuechange() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BillionValue(value) {
            var plainVal = value.replace(/,/g, "");
            return parseInt(plainVal / 1000000000, 000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, '');
        }
        function thousandsvalue(value) {
            var plainVal = value.replace(/,/g, "");
            return parseInt(plainVal / 1000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, '');
        }
        function MillionValue(value) {
            var plainVal = value.replace(/,/g, "");
            return parseInt(plainVal / 1000000).toLocaleString('en-US', { minimumFractionDigits: 0 }, { style: 'decimal' }).replace(/[$]/g, '');
        }


        function RestructureQuan() {
            try {
                if (AMLRaViewModel.Type() === 'F') {
                    $('#tblRAQuan tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAQuan thead').css("left", -$("#tblRAQuan tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAQuan thead th:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAQuan tbody td:nth-child(1)').css("left", $("#tblRAQuan tbody").scrollLeft()); //fix the first column of tdbody
                    });
                } else if (AMLRaViewModel.Type() === 'A') {
                    $('#tblRAQuanOverAllQ tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAQuanOverAllQ thead').css("left", -$("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAQuanOverAllQ thead th:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAQuanOverAllQ tbody td:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first column of tdbody
                        $('#tblRAQuanOverAllQ tbody th:nth-child(1)').css("left", $("#tblRAQuanOverAllQ tbody").scrollLeft()); //fix the first column of tdbody
                    });

                }
                if (AMLRaViewModel.Query() != "") {
                    SearchResult();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateDistributionData() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function RestructureQualitative() {
            try {
                $("#QualGrid").show();


                if (AMLRaViewModel.Type() === 'A') {
                    $('#tblRAQual tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAQual thead').css("left", -$("#tblRAQual tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAQual thead th:nth-child(1)').css("left", $("#tblRAQual tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAQual tbody td:nth-child(1)').css("left", $("#tblRAQual tbody").scrollLeft()); //fix the first column of tdbody
                    });
                    $("#QualInnerGrid").show();
                } else if (AMLRaViewModel.Type() === 'O') {
                    $("#QualOverallGrid").show();
                    $('#tblRAQualOverall tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAQualOverall thead').css("left", -$("#tblRAQualOverall tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAQualOverall thead th:nth-child(1)').css("left", $("#tblRAQualOverall tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAQualOverall tbody td:nth-child(1)').css("left", $("#tblRAQualOverall tbody").scrollLeft()); //fix the first column of tdbody
                    });
                }
                if (AMLRaViewModel.Query() != "") {
                    SearchResult();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RestructureQualitative() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        // #endregion

        // #region TreeView

        function NavigationMenuHideShow(data) {
            try {
                if (data == "Hide") {
                    // Hides Area NavigationMenu
                    $('#HideNavMenu').hide();
                    $('#ShowNavMenu').show();
                    $('#FilterAreaAccordionInhRA').hide();
                    $("#bottomDivAreaType").removeClass("col-lg-9").addClass("col-lg-12");
                    $(".rabrd").addClass("raBreadcrumb");

                }
                else {
                    // Shows Area NavigationMenu
                    $('#HideNavMenu').show();
                    $('#ShowNavMenu').hide();
                    $('#FilterAreaAccordionInhRA').show();
                    $("#bottomDivAreaType").removeClass("col-lg-12").addClass("col-lg-9");
                    $(".rabrd").removeClass("raBreadcrumb");
                }

                if (AMLRaViewModel.ClickedRiskAreaType() === 'QUAL')
                    RestructureQualitative();
                else
                    RestructureQuan();

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == ((!AMLRaViewModel.LocaleCheckFlag() || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLRaViewModel.ObjGeneralSettings.LocalizedTextList()[AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                $('#jsTreeAreaLevelInhRA').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text((!AMLRaViewModel.LocaleCheckFlag() || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : AMLRaViewModel.ObjGeneralSettings.LocalizedTextList()[AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpan").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                $('#jsTreeAreaLevelInhRA').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text((!AMLRaViewModel.LocaleCheckFlag() || AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLRaViewModel.ObjGeneralSettings.LocalizedTextList()[AMLRaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpan").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        function ExpandAllTreeView() {
            $('#jsTreeAreaLevelInhRA').treeview('expandAll', { silent: true });
        }

        function SearchTreeView() {
            $('#jsTreeAreaLevelInhRA').treeview('search', ['Parent', {
                ignoreCase: true,
                exactMatch: false,
                revealResults: true,
            }]);
        }

        function InitiateLevelTree() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getjsTreeAreaLevelInhRA = {
                    url: "/api/Configuration/GetEALData",
                    type: "GET",
                    data: { RiskAreType: AMLRaViewModel.SurveyTypeClicked(), SurveyCategoryID: AMLRaViewModel.SelectedSurveyComponentId().toString(), AssessmentTypes: AMLRaViewModel.AssessmentTypeId().toString(), ScreenType: 'RA' },
                    headers: headers
                };
                $.ajax(getjsTreeAreaLevelInhRA)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult.Incident_Description == null) {
                    //implement js tree logic here
                    AMLRaViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevelInhRA').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });
                    //for initial load expand for treeview
                    var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                    AMLRaViewModel.hasChildNodes(hasChildNodes);

                    $("#jsTreeAreaLevelInhRA ul:first li:first").trigger("click");
                }
                else {
                    if (jsonResult == null || jsonResult == undefined) {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
                    }
                    else {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLRaViewModel), true);
                    }
                }
            }

            function filterJsTree(TreeStructure) {
                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }
                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;
                    }
                );
            }

            function nodeClickEvent(event, node) {
                // Your logic goes here
                AMLRaViewModel.Type(node.RA_Type());
                $('#jsTreeAreaLevelInhRA').treeview('selectNode', [node.nodeId, { silent: true }]);
                if (node.dead_node == 1) {

                    if (AMLRaViewModel.ClickedRiskAreaType() == 'QTDR') {
                        $('#QuanFactorGrid').hide();
                        $('#QuanAreaGrid').hide();
                        $('#RiskLevelDataTab').hide();
                        AMLRaViewModel.countEntry(false)
                        AMLRaViewModel.ClickedRiskFactor(node.id);
                        AMLRaViewModel.ClickedRiskFactorName(node.text);
                        $('#RiskLevelTabinnerDiv').empty();
                        $('#RiskLevelInnerTabDivforHeatmap').empty();
                        AMLRaViewModel.RiskFactorFlag(true);
                        $('#Subfactordata').prop('checked', true);
                        AMLRaViewModel.DistributionFlag(false);
                        $('#Riskfactorevent').prop('checked', false);
                        $("#ThresholdsBtn").show();
                        $("#FactorReportDownload").show();
                        AMLRaViewModel.IsOverall(0);
                        AMLRaViewModel.Type('F');
                        GetAllQuantitativeData();
                    }
                    else {
                        $("#QualInnerGrid").hide();
                        $("#QualOverallGrid").hide();
                        AMLRaViewModel.HeatmapFlag(false);
                        $('#HeatmapToggleeventQualRA').prop('checked', false);
                        AMLRaViewModel.ClickedRiskAreaId(parseInt(node.id));
                        AMLRaViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                        GetAllQualitativeData();
                    }

                } else {
                    AMLRaViewModel.ClickedRiskAreaId(parseInt(node.id));
                    AMLRaViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());

                    if (AMLRaViewModel.ClickedRiskAreaType() == 'QTDR') {
                        $('#QuanAreaGrid').hide();
                        $('#QuanFactorGrid').hide();
                        AMLRaViewModel.IsOverall(1);
                        AMLRaViewModel.RiskFactorFlag(true);
                        $('#SubfactordataOverAll').prop('checked', true);
                        AMLRaViewModel.Type('A');
                        GetAllQuantitativeData();
                        $("#FactorReportDownload").hide();
                        $("#RiskLevelDataTab").hide();
                        $("#ThresholdsBtn").hide();
                    } else {
                        $("#QualInnerGrid").hide();
                        $("#QualOverallGrid").hide();
                        GetAllQualitativeData();
                    }
                }
                AMLRaViewModel.Query('');
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in AmlInherentRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            };
        }



        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (AMLRaViewModel.AreaLeveljstree()[self.id].length > 0 && item.DeadNode == 0) {
                self.nodes = $.map(AMLRaViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
        }


        // #endregion

        //#region Search

        function ClearResult() {
            try {
                if (event.which == 13) {
                    if (AMLRaViewModel.Query() != "") {
                        SearchResult();
                    }
                }
                if (AMLRaViewModel.Query() != "") {
                    $(".reset-search").show();
                    return false;
                }
                else {
                    $(".reset-search").hide();
                    ResetSearch();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearResult() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ResetSearch() {
            try {
                AMLRaViewModel.Query('');
                if (AMLRaViewModel.ClickedRiskAreaType() == 'QUAL') {

                    if (AMLRaViewModel.SubFactorGridDataListQual() != undefined) {
                        for (var i = 0; i < AMLRaViewModel.SubFactorGridDataListQual().length; i++) {
                            $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataListQual()[i].SubFactorId()).show();
                        }
                    }
                } else {
                    if (AMLRaViewModel.SubFactorGridDataList() != undefined) {
                        for (var j = 0; j < AMLRaViewModel.SubFactorGridDataList().length; j++) {
                            $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataList()[j].SubFactorId).show();
                        }
                    }
                    if (AMLRaViewModel.Type() == 'F' && AMLRaViewModel.DistributionFlag() == true) {
                        for (var k = 0; k < AMLRaViewModel.DistributionDataList().length; k++) {
                            $(".dtaxo_" + AMLRaViewModel.DistributionDataList()[k].RiskScoreId).show();
                        }
                    }
                }
                $(".reset-search").hide();
                //ExpandAll();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SearchResult() {
            try {
                if (AMLRaViewModel.ClickedRiskAreaType() == 'QUAL') {

                    if (AMLRaViewModel.SubFactorGridDataListQual() != undefined && AMLRaViewModel.SubFactorGridDataListQual().length > 0) {
                        var searchedList = '';
                        var q = AMLRaViewModel.Query();

                        searchedList = ko.utils.arrayFilter(AMLRaViewModel.SubFactorGridDataListQual(), function (item) {
                            if (q != "") {
                                if (item.SubFactorName().toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                    return item.SubFactorName().toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                }
                            }
                        });

                        for (var i = 0; i < AMLRaViewModel.SubFactorGridDataListQual().length; i++) {
                            $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataListQual()[i].SubFactorId()).hide();
                        }

                        if (AMLRaViewModel.Query() != undefined && AMLRaViewModel.Query() == "") {
                            //for empty keyboard input
                            for (var i = 0; i < AMLRaViewModel.SubFactorGridDataListQual().length; i++) {
                                $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataListQual()[i].SubFactorId()).show();
                            }
                        }
                        if (searchedList != undefined) {
                            for (var j = 0; j < searchedList.length; j++) {
                                for (var i = 0; i < AMLRaViewModel.SubFactorGridDataListQual().length; i++) {
                                    if (AMLRaViewModel.SubFactorGridDataListQual()[i].SubFactorId() == searchedList[j].SubFactorId()) {
                                        $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataListQual()[i].SubFactorId()).show();
                                    }
                                }
                            }
                        }
                    }
                }
                else if (AMLRaViewModel.ClickedRiskAreaType() != 'QUAL') {

                    if (AMLRaViewModel.SubFactorGridDataList() != undefined && AMLRaViewModel.SubFactorGridDataList().length > 0) {
                        var searchedList = '';
                        var q = AMLRaViewModel.Query();

                        searchedList = ko.utils.arrayFilter(AMLRaViewModel.SubFactorGridDataList(), function (item) {
                            if (q != "") {
                                if (item.SubFactorName.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                    return item.SubFactorName.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                }
                            }
                        });

                        for (var i = 0; i < AMLRaViewModel.SubFactorGridDataList().length; i++) {
                            $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataList()[i].SubFactorId).hide();
                        }

                        if (AMLRaViewModel.Query() != undefined && AMLRaViewModel.Query() == "") {
                            //for empty keyboard input
                            for (var i = 0; i < AMLRaViewModel.SubFactorGridDataList().length; i++) {
                                $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataList()[i].SubFactorId).show();
                            }
                        }
                        if (searchedList != undefined) {
                            for (var j = 0; j < searchedList.length; j++) {
                                for (var i = 0; i < AMLRaViewModel.SubFactorGridDataList().length; i++) {
                                    if (AMLRaViewModel.SubFactorGridDataList()[i].SubFactorId == searchedList[j].SubFactorId) {
                                        $(".raTaxo_" + AMLRaViewModel.SubFactorGridDataList()[i].SubFactorId).show();
                                    }
                                }
                            }
                        }
                    }

                    if (AMLRaViewModel.Type() == 'F' && AMLRaViewModel.DistributionFlag() == true) {
                        //$root.DistributionDataList
                        if (AMLRaViewModel.DistributionDataList() != undefined && AMLRaViewModel.DistributionDataList().length > 0) {
                            var searchedList = '';
                            var q = AMLRaViewModel.Query();

                            searchedList = ko.utils.arrayFilter(AMLRaViewModel.DistributionDataList(), function (item) {
                                if (q != "") {
                                    if (item.RiskLevelText.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                        return item.RiskLevelText.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                    }
                                }
                            });

                            for (var i = 0; i < AMLRaViewModel.DistributionDataList().length; i++) {
                                $(".dtaxo_" + AMLRaViewModel.DistributionDataList()[i].RiskScoreId).hide();
                            }

                            if (AMLRaViewModel.Query() != undefined && AMLRaViewModel.Query() == "") {
                                //for empty keyboard input
                                for (var i = 0; i < AMLRaViewModel.DistributionDataList().length; i++) {
                                    $(".dtaxo_" + AMLRaViewModel.DistributionDataList()[i].RiskScoreId).show();
                                }
                            }
                            if (searchedList != undefined) {
                                for (var j = 0; j < searchedList.length; j++) {
                                    for (var i = 0; i < AMLRaViewModel.DistributionDataList().length; i++) {
                                        if (AMLRaViewModel.DistributionDataList()[i].RiskScoreId == searchedList[j].RiskScoreId) {
                                            $(".dtaxo_" + AMLRaViewModel.DistributionDataList()[i].RiskScoreId).show();
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

    });

